import { ASSESSMENT_STEP_NAMES, STATUS_LABELS } from '../../constants';

interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
  status: string;
  className?: string;
}

export const StepProgress = ({
  currentStep,
  totalSteps,
  status,
  className = '',
}: StepProgressProps) => {
  const safeTotal = Math.max(totalSteps, 1);
  const safeStep = Math.max(0, Math.min(currentStep, safeTotal));
  const percentage = Math.round((safeStep / safeTotal) * 100);
  const isCompleted = currentStep === totalSteps;

  const stepName = ASSESSMENT_STEP_NAMES[currentStep] ?? `Step ${currentStep}`;
  const statusLabel = STATUS_LABELS[status] ?? status;

  return (
    <div
      className={`flex flex-col items-flex-start p-0 gap-1 w-full ${className}`}
      role="group"
      aria-label="Assessment Progress"
    >
      {/* Step Label and Count */}
      <div className="flex flex-row items-flex-start p-0 gap-1 w-full h-4">
        <span className="flex-1 font-['Inter'] font-normal text-xs leading-4 text-[#62748E]">
          {stepName}
        </span>
        <span className="font-['Inter'] font-normal text-xs leading-4 text-[#62748E]">
          Step {safeStep} of {totalSteps}
        </span>
      </div>

      {/* Progress Bar */}
      <div
        className="w-full h-1 bg-[#E2E8F0] rounded-lg overflow-hidden relative"
        role="progressbar"
        aria-valuenow={safeStep}
        aria-valuemin={0}
        aria-valuemax={totalSteps}
        aria-label={`${statusLabel}: ${stepName}`}
      >
        <div
          className={`absolute left-0 top-0 h-full rounded-lg ${isCompleted ? 'bg-[#17C964]' : 'bg-[#006FEE]'}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};
